/* Helpers compartidos del módulo Apps (Plataforma de Micro-Productos IA) */
import type { EstadoApp, ModeloCobro } from '@/lib/types'

export const ESTADOS_APP: EstadoApp[] = ['produccion', 'proximamente', 'por_desplegar', 'pausada', 'deprecada']

export const ESTADO_META: Record<EstadoApp, { label: string; color: string; bg: string }> = {
  produccion: { label: 'En producción', color: 'var(--success)', bg: 'var(--success-bg)' },
  // Lista técnicamente, pendiente de precio. No se muestra al cliente en el portal.
  proximamente: { label: 'Próximamente', color: 'var(--primary-light)', bg: 'var(--primary-soft)' },
  por_desplegar: { label: 'Por desplegar', color: 'var(--warning)', bg: 'var(--warning-bg)' },
  pausada: { label: 'Pausada', color: 'var(--text-muted)', bg: 'var(--veil-10)' },
  deprecada: { label: 'Deprecada', color: 'var(--danger)', bg: 'var(--danger-bg)' },
}

/** Resumen de una línea del modelo de cobro, para tablas y tarjetas. */
export function cobroResumen(mc: ModeloCobro | null | undefined): string {
  if (!mc || Object.keys(mc).length === 0) return '—'
  if (mc.tipo === 'por_modelo' && Array.isArray(mc.tarifas) && mc.tarifas.length > 0) {
    return `Por modelo · ${mc.tarifas.length} ${mc.tarifas.length === 1 ? 'tarifa' : 'tarifas'}`
  }
  if (mc.creditos != null) return `${mc.creditos} créd / ${mc.unidad || 'uso'}`
  return mc.descripcion || '—'
}
